import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Dialog } from 'LegacyWeployDesignLanguage/Modal';
import { Button } from 'LegacyWeployDesignLanguage/buttons';

const ButtonContainer = styled.div`
  display: flex;
  padding: ${props => props.theme.space.single};
  justify-content: space-between;
`;

const MessageContainer = styled.div`
  display: flex;
  align-content: center;
  justify-content: center;
  padding: ${props => props.theme.space.single};
  padding-bottom: 0;
  margin-bottom: ${props => props.theme.space.single};
`;

class ConfirmCancelDialog extends Component {
  render() {
    const {
      message,
      closeMessage,
      confirmMessage,
      open,
      onClose,
      onConfirm,
    } = this.props;

    return (
      <Dialog
        open={open}
        onClose={onClose}
      >
        <MessageContainer>{message}</MessageContainer>
        <ButtonContainer>
          <Button
            type="button"
            onClick={onClose}
            appearance={Button.SECONDARY}
          >
            {closeMessage}
          </Button>
          <Button
            type="button"
            onClick={onConfirm}
          >
            {confirmMessage}
          </Button>
        </ButtonContainer>
      </Dialog>
    );
  }
}

ConfirmCancelDialog.propTypes = {
  message: PropTypes.string.isRequired,
  closeMessage: PropTypes.string,
  confirmMessage: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
};

ConfirmCancelDialog.defaultProps = {
  open: false,
  closeMessage: 'No',
  confirmMessage: 'Yes',
  onConfirm: () => {},
};

export default ConfirmCancelDialog;
